import React, { useEffect, useRef, useState } from "react";
import { ChevronUp } from "lucide-react";

const RADIUS = 20;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const SHOW_THRESHOLD = 300;

const ScrollToTop: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const progressRef = useRef<SVGCircleElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const docHeight =
        document.documentElement.scrollHeight - document.documentElement.clientHeight;
      const scrollPercent = docHeight > 0 ? Math.min(scrollTop / docHeight, 1) : 0;

      if (progressRef.current) {
        progressRef.current.style.strokeDashoffset = String(
          CIRCUMFERENCE - scrollPercent * CIRCUMFERENCE
        );
      }

      setIsVisible(scrollTop > SHOW_THRESHOLD);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Retour en haut de la page"
      className={`fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full border-2 border-primary bg-white text-primary shadow-lg transition-all duration-300 ease-out hover:bg-primary hover:text-white ${
        isVisible
          ? "translate-y-0 opacity-100"
          : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <svg
        className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 -rotate-90"
        width="48"
        height="48"
        viewBox="0 0 48 48"
      >
        <circle
          className="opacity-20"
          stroke="#00553E"
          strokeWidth="2"
          fill="transparent"
          r={RADIUS}
          cx="24"
          cy="24"
        />
        <circle
          ref={progressRef}
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          fill="transparent"
          r={RADIUS}
          cx="24"
          cy="24"
          strokeDasharray={CIRCUMFERENCE}
          strokeDashoffset={CIRCUMFERENCE}
          style={{ transition: "stroke-dashoffset 0.2s ease" }}
        />
      </svg>
      <ChevronUp size={20} strokeWidth={2.5} className="relative z-10" />
    </button>
  );
};

export default ScrollToTop;
